import { useAppSelector, useTexts } from "../../../hooks";
import { formatCurrency, getClasses } from "../../../utils";
import IconButton from "../../buttons/IconButton";
import PrivateAPI from "../../../commander/PrivateAPI";
import classes from "../../../styles/Modal.module.css";

const StakeSelector: React.FC<{}> = () => {
  const { common } = useTexts();
  const { stake, currency } = useAppSelector(({ selectors, details }) => {
    return { stake: selectors.stake, currency: details.currency };
  });
  const stakeIndex = stake.possibleValues.indexOf(stake.value);

  const onClick = (direction: 1 | -1) => {
    const stakeIndex = stake.possibleValues.indexOf(stake.value);
    const nextIndex = Math.max(
      Math.min(stakeIndex + direction, stake.possibleValues.length - 1),
      0
    );

    PrivateAPI.setStake(stake.possibleValues[nextIndex]);
  };

  return (
    <div className={classes["stake-selector"]}>
      <div className={getClasses(classes, "title")}>
        {common.stake ?? "stake:"}
      </div>
      <div className={classes.selector}>
        <IconButton
          className="flipped color fill-pale"
          type="Chevron"
          size={30}
          onClick={onClick.bind(null, -1)}
          disabled={stakeIndex === 0}
          name="stake-selector-previous"
        />
        <div className={classes.label}>
          {formatCurrency(stake.value, currency)}
        </div>
        <IconButton
          className="color fill-pale"
          type="Chevron"
          size={30}
          name="stake-selector-next"
          onClick={onClick.bind(null, 1)}
          disabled={stakeIndex === stake.possibleValues.length - 1}
        />
      </div>
    </div>
  );
};

export default StakeSelector;
